var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeName==='home')?_c('mobile-home',{attrs:{"showRegister":_vm.showRegister},on:{"editMenu":_vm.editMenu}}):_c('mobile-nav',{attrs:{"activeName":_vm.activeName},on:{"editMenu":_vm.editMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }